import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';

const StyledCheckboxField = styled.div`
  ${(props) => props.customStyles}
  ${(props) => props.defaultStyles}
`;

export default function CheckboxField({
  name,
  id,
  onChange,
  customStyles,
  checked = false,
  label = '',
  labelClassName = 'text-gray-500',
}) {
  const { whiteLabelSettings: { secondaryColour } = {} } =
    useWhiteLabelSettings();
  const [fieldId, setFieldId] = useState();

  useEffect(() => {
    setFieldId(id || uuid());
  }, [id]);

  const onChangeHandler = (event) => {
    onChange?.(event);
  };

  const defaultStyles = `
    display: flex;
    align-items: center;
    padding: 0 24px;

    input:checked[type='checkbox'] {
      color: ${secondaryColour};
      background-color: ${secondaryColour};
      border-color: ${secondaryColour};
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E");
    }
  `;

  return (
    <StyledCheckboxField
      customStyles={customStyles}
      defaultStyles={defaultStyles}
    >
      <input
        className="appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white focus:outline-none transition duration-100 align-top bg-no-repeat bg-center bg-contain float-left cursor-pointer"
        type="checkbox"
        id={fieldId}
        name={name}
        checked={checked}
        onChange={onChangeHandler}
      />
      <div className="border-r border-[#FAFAFA] pl-[16px] py-[24px] h-[30px]" />
      <label htmlFor={fieldId}>
        <div className={labelClassName}>{label}</div>
      </label>
    </StyledCheckboxField>
  );
}
